import React, { useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem, Label, Row, Col, Input, FormGroup, Button, Card, CardBody, TabContent, TabPane, CardHeader, ButtonGroup } from 'reactstrap';
import { RiCactusFill } from 'react-icons/ri';
import toast, { Toaster } from 'react-hot-toast';
import Loading from '../components/modales/loadingModal';
import { withAuthenticationRequired } from "@auth0/auth0-react";

//Redux
import { connect } from 'react-redux';

//Componentes
import ModalEmail from './modales/confirmEmailModal';

const mapStateToProps = state => ({
    usuarioActivo: state
})

let PanelInfo = (props) => {
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [activeTab, setActiveTab] = useState('1')
    const [modalEmail, setModalEmail] = useState(!(props.userData[0].eee_mail === userData.email))
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    useEffect(() => {
        document.title = "Información de Usuario";
    })

    const setTabActiva = (tab) => {
        setActiveTab(tab)
    }

    const getButtons = () => {
        console.log(props.userData)
        return Object.keys(props.userData).map((key, index) => {
            return (
                <Button
                    key={`btn_${index}`} 
                    color="primary"
                    className={`btn-shadow + ${((index + 1).toString() === activeTab ? 'active' : '')}`}
                    onClick={() => {
                        setTabActiva(`${index + 1}`);
                    }}
                >{`Contrato ${index + 1}`}</Button>
            );
        });
    }

    const getTipoSalario = (tipo) => {
        switch (tipo) {
            case 'I':
                return 'INTEGRAL'
            case 'F':
                return 'FIJO'
            default:
                return 'FIJO'
        }
    }

    const getTipoContrato = (data) => {
        if (data.tip_cont !== null && data.TIP_CNFJ !== null) {
            if (data.tip_cont === 'F' && data.TIP_CNFJ === 'F') { return 'FIJO' }
            if (data.tip_cont === 'F' && data.TIP_CNFJ === 'M') { return 'MESA LABORAL' }
            if (data.tip_cont === 'I' && data.TIP_CNFJ === 'L') { return 'OBRA O LABOR' }
            if (data.tip_cont === 'I' && data.TIP_CNFJ === 'N') { return 'INDEFINIDO' }
        }
        else return 'Sin informacion de contrato'
    }

    const getContent = () => {
        return Object.keys(props.userData).map((key, index) => {
            let userData = props.userData[key]
            return (
                <TabPane 
                    key={`tabPane_${index}`}
                    tabId={`${index + 1}`}>
                    <Row>
                        <Col xs="12" sm="12">
                            <Breadcrumb>
                                <BreadcrumbItem active>Informacion General</BreadcrumbItem>
                            </Breadcrumb>
                            <Row>
                                <Col md='6' xs="12">
                                    <Label key={`${index}_label_nombre`}>
                                        Nombre
                            </Label>
                                    <Input disabled type="text" name="name" id={`${index}infoContractualName`} placeholder="Nombre" defaultValue={(userData !== undefined && userData !== null) ? `${userData.nom_empl.split(" ")[0]} ${userData.nom_empl.split(" ")[1]} ${userData.ape_empl.split(" ")[0]} ${userData.ape_empl.split(" ")[1]}` : 'Sin nombre'} />
                                </Col>
                                <Col md='6' xs="12">
                                    <Label key={`${index}_label_cargo`}>
                                        Cargo
                            </Label>
                                    <Input disabled type="text" name="cargo" id={`${index}infoContractualCargo`} placeholder="Cargo" defaultValue={(userData.nom_carg !== undefined && userData.nom_carg !== null) ? `${userData.nom_carg}` : 'Sin cargo'} />
                                </Col>
                            </Row>
                            <br />
                            <Breadcrumb>
                                <BreadcrumbItem active>Datos Contractuales</BreadcrumbItem>
                            </Breadcrumb>
                            <FormGroup>
                                <Row>
                                    <Col md='3' xs="12">
                                        <Label key={`${index}_label_jefe`}>
                                            Jefe Inmediato
                                        </Label>
                                        <Input disabled type="text" name="jefe" id={`${index}infoJefe`} placeholder="with a placeholder" defaultValue={(userData.nom_jefe !== undefined && userData.nom_jefe !== null) ? `${userData.nom_jefe.split(" ")[0]} ${userData.nom_jefe.split(" ")[1]} ${userData.ape_jefe.split(" ")[0]} ${userData.ape_jefe.split(" ")[1]}` : 'Sin Registro'} />
                                    </Col>
                                    <Col md='3' xs="12">
                                        <Label key={`${index}_label_tipo_contrato`}>
                                            Tipo de Contrato
                                        </Label>
                                        <Input disabled type="text" name="tipoContrato" id={`${index}infoTipoContrato`} placeholder="with a placeholder" defaultValue={(userData !== undefined && userData !== null) ? `${getTipoContrato(userData)}` : 'Sin Registro'} />
                                    </Col>
                                    <Col md='3' xs="12">
                                        <Label key={`${index}_label_fecha_inicio`}>
                                        Fecha de Inicio
                                        </Label>
                                        <Input disabled type="text" name="Campo" id={`${index}infoContractuaFechaIni`} placeholder="with a placeholder" defaultValue={(userData !== undefined && userData.fec_cont !== null && userData.fec_cont !== 'null') ? `${new Date(((new Date(userData.fec_cont.split("T")[0]).getTime() / 1000) + 18000) * 1000).toLocaleString('es-ES', options)}` : 'Sin Registro'} />
                                    </Col>
                                    <Col md='3' xs="12">
                                        <Label key={`${index}_label_fecha_vencimiento`}>
                                        Fecha Vencimiento
                                        </Label>
                                        <Input disabled type="text" name="riesgo" id={`${index}infoContractualFechaFin`} placeholder="with a placeholder" defaultValue={(userData !== undefined && userData.fec_venc !== null && userData.fec_venc !== 'null') ? `${new Date(((new Date(userData.fec_venc.split("T")[0]).getTime() / 1000) + 18000) * 1000).toLocaleString('es-ES', options)}` : 'Sin Registro'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_contrato`}>
                                            Contrato
                                        </Label>
                                        <Input disabled type="text" name="contrato" id={`${index}infoContractualContrato`} placeholder="with a placeholder" defaultValue={(userData.nom_tnom !== undefined && userData.nom_tnom !== null) ? `${userData.nom_tnom}` : 'Sin Registro'} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_campo`}>
                                            Campo
                                        </Label>
                                        <Input disabled type="text" name="Campo" id={`${index}infoContractualCampo`} placeholder="with a placeholder" defaultValue={(userData.nom_cenp !== undefined && userData.nom_cenp !== null) ? `${userData.nom_cenp}` : 'Sin Registro'} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_gerencia`}>
                                            Gerencia
                                        </Label>
                                        <Input disabled type="text" name="gerencia" id={`${index}infoGerencia`} placeholder="with a placeholder" defaultValue={(userData.fol_cont !== undefined && userData.fol_cont !== null) ? `${userData.fol_cont}` : 'Sin Registro'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_riesgo`}>
                                            Riesgo %
                                        </Label>
                                        <Input disabled type="text" name="riesgo" id={`${index}infoContractualRiesgo`} placeholder="with a placeholder" defaultValue={(userData.tar_atep !== undefined && userData.tar_atep !== null) ? `${parseFloat(userData.tar_atep).toFixed(3)} %` : '0.000%'} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_tipoSalario`}>
                                            Tipo de Salario
                                        </Label>
                                        <Input disabled type="text" name="tipoSalario" id={`${index}infoTipoSalario`} placeholder="with a placeholder" defaultValue={(userData.tip_sala !== undefined && userData.tip_sala !== null) ? `${getTipoSalario(userData.tip_sala)}` : ''} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_salario`}>
                                            Salario
                                        </Label>
                                        <Input disabled type="text" name="salario" id={`${index}infoContractualSalario`} placeholder="with a placeholder" defaultValue={(userData.sue_basi !== undefined && userData.sue_basi !== null) ? `$ ${parseFloat(userData.sue_basi).toLocaleString()}` : ''} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <Breadcrumb>
                                <BreadcrumbItem active>Auxilios Economicos</BreadcrumbItem>
                            </Breadcrumb>
                            <FormGroup>
                                <Row>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_aux_alim`}>
                                            Alimentación
                                        </Label>
                                        <Input disabled type="text" name="alimentacionAux" id={`${index}infoContractualAlimentacion`} placeholder="with a placeholder" defaultValue={(userData.con_fij1 !== undefined && userData.con_fij1 !== null) ? `$ ${parseFloat(userData.con_fij1).toLocaleString()}` : '$ 0'} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_aux_mov`}>
                                            Movilidad
                                        </Label>
                                        <Input disabled type="text" name="movilidadAux" id={`${index}infoContractualMovilidad`} placeholder="with a placeholder" defaultValue={(userData.con_fij2 !== undefined && userData.con_fij2 !== null) ? `$ ${parseFloat(userData.con_fij2).toLocaleString()}` : '$ 0'} />
                                    </Col>
                                    <Col md='4' xs="12">
                                        <Label key={`${index}_label_aux_loc`}>
                                            Locación
                                        </Label>
                                        <Input disabled type="text" name="locacionAux" id={`${index}infoContractualLocacion`} placeholder="with a placeholder" defaultValue={(userData.con_fij3 !== undefined && userData.con_fij3 !== null) ? `$ ${parseFloat(userData.con_fij3).toLocaleString()}` : '$ 0'} />
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                    </Row>
                </TabPane>
            );
        });
    }
    return (
        <React.Fragment>
            <Toaster/>
            <ModalEmail 
                modal={modalEmail}
                email={userData.email}
                toggle={() => { setModalEmail(false) }}
            />
            <Card className="main-card mb-3">
                <CardHeader>
                    Informacion Contractual
                                        <div className="btn-actions-pane-right">
                        <ButtonGroup size="sm">
                            {getButtons()}
                        </ButtonGroup>
                    </div>
                </CardHeader>
                <CardBody>

                    <TabContent activeTab={activeTab}>
                        {getContent()}
                    </TabContent>
                </CardBody>
            </Card>
            <div className='link-to-kactus-area'>
                <a href="http://201.217.197.98:8085//" target="_blank">
                    <RiCactusFill size={20}/>
                    Ir a Kactus
                </a>
            </div>
        </React.Fragment>
    )
}


export default withAuthenticationRequired(connect(mapStateToProps)(PanelInfo), {
    onRedirecting: () => <Loading />,
  });